import styled from '@emotion/styled'

export const BadgeWrapper = styled.div`
  && * {
    cursor: pointer;
  }
`
